import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';
import { Container, Row, Col, Image,Button } from "react-bootstrap";
import GainMoreSliderImg from "../../../../assests/images/showcase-reviews-images/foundant-technologies.webp";
import GainMoreSliderImgOne from "../../../../assests/images/showcase-reviews-images/boostTrustConfidenceImg-1.webp";
import GainMoreSliderImgTwo from "../../../../assests/images/showcase-reviews-images/boostTrustConfidenceImg-2.webp";
import GainMoreSliderImgThree from "../../../../assests/images/showcase-reviews-images/boostTrustConfidenceImg-3.webp";
import GainMoreSliderImgFour from "../../../../assests/images/showcase-reviews-images/boostTrustConfidenceImg-4.webp";
import AfricanLibraryProject from "../../../../assests/images/showcase-reviews-images/african-library -project.webp";
import {
    ShowCaseTopSec,
    GainMoreExposureSection,
    GainMoreExposureWrap,
    GainMoreExposureSlider,
    GainMoreExposureTitle,
    GainMoreExposureContent,
    GainMoreExposureText,
    SwiperSlider,
    SliderItem,
    SliderItemImage,
    GainMoreSliderTitle,
    BoostTrustConfidence,
    BoostTrustConfidenceWrap,
    BoostTrustConfidenceContent,
    BoostTrustConfidenceTitle,
    BoostTrustConfidenceText,
    BoostTrustConfidenceImages,
    BoostTrustConfidenceImageList,
    StarBadgeSection,
    StarBadgeWrap,
    StarBadgeImage,
    StarBadgeContent,
    StarBadgeTitle,
    TopRatedStatus,
    TopRatedSlider,
    TopRatedStatusContent,
    TopRatedStatusTitle,
    TopRatedStatusText,
} from "./showCaseStyle"
import { useDispatch } from "react-redux";
import { starBadgeHandler } from "../../../../redux/slices/reviews/starBadge";
import { useNavigate } from "react-router-dom";
import {
    Title,
    WriteReviewSection,
    ReviewText,
    ReviewRightSection,
    RightBanner
} from "../../../../components/common/commonSubBanner/commonSubBannerStyle";

import showReviewsBanner from "../../../../assests/images/showyourreviews.webp";
import { MESSAGE } from "../../../../utils/message";
import MetaComponent from "../../../../components/common/metaComponent";
const ShowcaseReviews = () => {
    const dispatch: any = useDispatch();
    const navigate: any = useNavigate();
    const starBadgeScript =  {script: `<script type="text/javascript">
    gnp_url = 'greatnonprofits';gnp_num = '1';
</script>
<script src="https://qa.greatnonprofits.org/js/api/badge_reviews.js" type="text/
javascript"></script><noscript> <a href="https://qa.greatnonprofits.org/org/greatnonprofits/?badge=1"> <img
alt="Review greatnonprofits on Great Nonprofits" title="Review greatnonprofits on Great 
Nonprofits" src="//cdn.greatnonprofits.org/images/great-nonprofits.gif?id=93"> </a
></noscript>`,
 }

    useEffect(() => {
        dispatch(starBadgeHandler())
    }, [])

    return (
        <>
        <MetaComponent 
            keywords=""
            description=""
            ogTitle="Showcase Reviews | GreatNonprofits"
            ogDescription=""
            ogUrl="https://www.about.greatnonprofits.org/showcase-reviews"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
        <>
<ShowCaseTopSec>
    <WriteReviewSection className="showcase-reviews-banner">
        <Container className="cont-w">
            <Row>
                <Col lg={6} sm={12} md={12}>
                    <Title>Show Your Reviews</Title>
                    <ReviewText>When you have a GreatNonprofits profile page and reviews, you're gaining exposure to missions of donors and volunteers not only on greatnonprofits.org,
                        but also through our partners. </ReviewText>
                </Col>
                <Col lg={6} sm={12} md={12}>
                    <RightBanner className="left_banner">
                        <ReviewRightSection>
                            <Image src={showReviewsBanner} alt="ReviewImage" />
                        </ReviewRightSection>
                    </RightBanner>
                </Col>
            </Row>
        </Container>
    </WriteReviewSection>
</ShowCaseTopSec>

<GainMoreExposureSection>
    <Container className="cont-w">
        <Row className="gainMore-exposure-main">
            <Col lg="6">
                <GainMoreExposureWrap>
                    <GainMoreExposureTitle>{MESSAGE.gainMoreExposureReviewSyndication}</GainMoreExposureTitle>

                    <GainMoreExposureContent>
                        <GainMoreExposureText>That&#8218;s right! </GainMoreExposureText>
                        <GainMoreExposureText>GreatNonprofits works with GuideStar, JustGive, and dozens of other partners to showcase and power reviews about your nonprofit on those sites.</GainMoreExposureText>
                        <GainMoreExposureText>That means that when donors are going to GuideStar (for instance) to analyze you they&#8218;ll see your real-time reviews.</GainMoreExposureText>
                        <GainMoreExposureText>Now that&#8218;s powerful!</GainMoreExposureText>
                    </GainMoreExposureContent>

                </GainMoreExposureWrap>
            </Col>
            <Col lg="6">
                <GainMoreExposureSlider>
                    <SwiperSlider>
                        <Swiper
                            loop={true}
                            pagination={{
                                dynamicBullets: true,
                            }}
                            autoplay={{
                                delay: 1500,
                                disableOnInteraction: false,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="mySwiper"
                        >
                            <SwiperSlide>
                                <SliderItem>
                                    <SliderItemImage>
                                        <Image src={GainMoreSliderImg} alt="Gain More Slider Img" />
                                    </SliderItemImage>
                                    <GainMoreSliderTitle>GreatNonprofits & Foundant</GainMoreSliderTitle>
                                </SliderItem>
                            </SwiperSlide>

                            <SwiperSlide>
                                <SliderItem>
                                    <SliderItemImage>
                                        <Image src={GainMoreSliderImg} alt="Gain More Slider Img" />
                                    </SliderItemImage>
                                    <GainMoreSliderTitle>GreatNonprofits & Foundant</GainMoreSliderTitle>
                                </SliderItem>
                            </SwiperSlide>

                            <SwiperSlide>
                                <SliderItem>
                                    <SliderItemImage>
                                        <Image src={GainMoreSliderImg} alt="Gain More Slider Img" />
                                    </SliderItemImage>
                                    <GainMoreSliderTitle>GreatNonprofits & Foundant</GainMoreSliderTitle>
                                </SliderItem>
                            </SwiperSlide>

                            <SwiperSlide>
                                <SliderItem>
                                    <SliderItemImage>
                                        <Image src={GainMoreSliderImg} alt="Gain More Slider Img" />
                                    </SliderItemImage>
                                    <GainMoreSliderTitle>GreatNonprofits & Foundant</GainMoreSliderTitle>
                                </SliderItem>
                            </SwiperSlide>

                        </Swiper>
                    </SwiperSlider>
                </GainMoreExposureSlider>
            </Col>
        </Row>
    </Container>
</GainMoreExposureSection>

<BoostTrustConfidence>
    <Container className="cont-w">
        <Row className="gainMore-exposure-main">
            <Col lg="12">
                <BoostTrustConfidenceWrap>
                    <BoostTrustConfidenceContent>
                        <BoostTrustConfidenceTitle>{MESSAGE.boostTrustAndConfidence}</BoostTrustConfidenceTitle>
                        <BoostTrustConfidenceText>Did you know that, following the Better Business Bureau, the GreatNonprofits badge is the most trusted rating seal for donors?</BoostTrustConfidenceText>
                        <BoostTrustConfidenceText>Now you can choose from various colors and copy and paste the badge code to your website. When you use our code, badges can include your logo and star rating. We also have print versions you can use in direct mail and print materials!</BoostTrustConfidenceText>
                    </BoostTrustConfidenceContent>

                    <BoostTrustConfidenceImages>
                        <BoostTrustConfidenceImageList>
                            <Image src={GainMoreSliderImgOne} alt="Boost Trust Confidence Img" />
                            <Image src={GainMoreSliderImgTwo} alt="Boost Trust Confidence Img" />
                        </BoostTrustConfidenceImageList>
                        <BoostTrustConfidenceImageList><Image src={GainMoreSliderImgThree} alt="Boost Trust Confidence Img" /></BoostTrustConfidenceImageList>
                        <BoostTrustConfidenceImageList><Image src={GainMoreSliderImgFour} alt="Boost Trust Confidence Img" /></BoostTrustConfidenceImageList>
                    </BoostTrustConfidenceImages>

                </BoostTrustConfidenceWrap>
            </Col>
        </Row>
    </Container>
</BoostTrustConfidence>

<StarBadgeSection>
    <Container className="cont-w">
        <Row>
            <Col lg="12">
                <StarBadgeTitle>{MESSAGE.starBadge}</StarBadgeTitle>
                <StarBadgeWrap>
                    <StarBadgeImage>
                        <Image src={GainMoreSliderImgFour} alt="Boost Trust Confidence Img" />
                    </StarBadgeImage>
                    <StarBadgeContent>
                        {starBadgeScript?.script}
                    </StarBadgeContent>
                </StarBadgeWrap>
            </Col>
        </Row>
    </Container>
</StarBadgeSection>

<TopRatedStatus>
    <Container>
        <Row className="top-rated-main">
            <Col lg="6">
                <TopRatedSlider>
                    <SwiperSlider className="top-rated-slider">
                        <Swiper
                            loop={true}
                            pagination={{
                                dynamicBullets: true,
                            }}
                            autoplay={{
                                delay: 1500,
                                disableOnInteraction: false,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="mySwiper"
                        >
                            <SwiperSlide>
                                <SliderItem>
                                    <SliderItemImage>
                                        <Image src={AfricanLibraryProject} alt="    " />
                                    </SliderItemImage>
                                </SliderItem>
                            </SwiperSlide>

                            <SwiperSlide>
                                <SliderItem>
                                    <SliderItemImage>
                                        <Image src={AfricanLibraryProject} alt="African Library Project" />
                                    </SliderItemImage>
                                </SliderItem>
                            </SwiperSlide>

                            <SwiperSlide>
                                <SliderItem>
                                    <SliderItemImage>
                                        <Image src={AfricanLibraryProject} alt="African Library Project" />
                                    </SliderItemImage>
                                </SliderItem>
                            </SwiperSlide>

                            <SwiperSlide>
                                <SliderItem>
                                    <SliderItemImage>
                                        <Image src={AfricanLibraryProject} alt="African Library Project" />
                                    </SliderItemImage>
                                </SliderItem>
                            </SwiperSlide>

                        </Swiper>
                    </SwiperSlider>
                </TopRatedSlider>
            </Col>
            <Col lg="6">
                <TopRatedStatusContent>
                    <TopRatedStatusTitle>{MESSAGE.getRecognitionShowOffTopRatedStatus}</TopRatedStatusTitle>

                    <TopRatedStatusText>All Top-Rated Awards winners get the FREE GreatNonprofits Top-Rated badge.</TopRatedStatusText>
                    <TopRatedStatusText>According to a research conducted by Software advice, the GreatNonprofits Top-Rated Badge is one of the most trusted among donors.</TopRatedStatusText>
                    <TopRatedStatusText>This badge can be used on your nonprofit website and marketing materials to show off your organization's status and impact.</TopRatedStatusText>
                    <TopRatedStatusText>For more information on the GreatNonprofit Top-Rated Awards, visit our microsite at www.toprated.greatnonprofits.org or click the button below.</TopRatedStatusText>

                    <Button onClick={() => navigate("/detail-award")} className="learn-more-btn btn" type="button">{MESSAGE.learnMoreBtn}</Button>
                </TopRatedStatusContent>
            </Col>
        </Row>
    </Container>
</TopRatedStatus>

</>
        </>
    )
};
export default ShowcaseReviews;